import { useEffect, useState } from 'react';

import { observer } from 'mobx-react';

import { DEFAULT_LANGUAGE } from '../../i18n/constants';
import { getUserLanguage } from '../../i18n/helpers';
import { useStores } from '../../stores/useStores';
import { LanguageSelect } from '../LanguageSelect/LanguageSelect';
import type { LanguageOption } from '../LanguageSelect/types';

import { LANGUAGE_OPTIONS_BY_ID, LANGUAGES_OPTIONS } from './constants';

type Props = {
  showTitlePrefixIcon?: boolean;
};
export const ChangeLanguage: React.FC<Props> = observer(function ChangeLanguage({ showTitlePrefixIcon }) {
  const [selectedLanguage, setSelectedLanguage] = useState<LanguageOption>(LANGUAGE_OPTIONS_BY_ID[DEFAULT_LANGUAGE]);

  const { userStore, authStore, gameStore, cmsStore } = useStores();
  const { language } = userStore.profile || {};

  const onChange = (lang: LanguageOption) => {
    setSelectedLanguage(lang);
    void authStore.updateUserProfile({ language: lang.id });
    userStore.updateProfile({ language: lang.id });
    gameStore.sendSlotsGameUiMessage({ type: 'setLanguage', payload: { language: lang.id } });
    void cmsStore.fetchLinks(lang.id);
    void cmsStore.fetchFooter(lang.id);
  };

  useEffect(() => {
    if (language) {
      setSelectedLanguage(LANGUAGE_OPTIONS_BY_ID[getUserLanguage(language)]);
    }
  }, [language]);

  return (
    <LanguageSelect
      name="language"
      options={LANGUAGES_OPTIONS}
      showSingleValuePrefixIcon={showTitlePrefixIcon}
      value={selectedLanguage}
      onChange={(newValue) => newValue && onChange(newValue)}
    />
  );
});
